import { apiFetch } from "./apiClient";

/**
 * Fire-and-forget hover prefetch for a template's content.
 *
 * Call on mouseenter of a template card. Stores the pending promise on window
 * so ContentEditingContext.loadContent() can consume it instead of making a
 * fresh request — shaving ~200–400ms off the perceived open time.
 */
export function prefetchTemplateContent(templateId: string): void {
  const key = `__ZAP_CONTENT_${templateId}`;
  if ((window as any)[key]) return; // already in flight or cached
  (window as any)[key] = apiFetch(`/content/${encodeURIComponent(templateId)}`).catch(
    () => null,
  );
}
